import { useState, type PropsWithChildren } from "react";
import {
  PrimaryNavigationStripFadeReachContext,
  createPrimaryNavigationStripFadeReachRegistry,
} from "#primary-navigation-strip-fade-reach-context";

/**
 * Wraps the tab navigator so scenes can stretch the bottom-tab fade above its default reach.
 */
export function PrimaryNavigationStripFadeReachProvider({ children }: PropsWithChildren) {
  const [registry] = useState(() => createPrimaryNavigationStripFadeReachRegistry());
  return (
    <PrimaryNavigationStripFadeReachContext.Provider value={registry}>
      {children}
    </PrimaryNavigationStripFadeReachContext.Provider>
  );
}
